export default __webpack_public_path__ + "assets/img/Left_chev_act.12d299c7.svg";